import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import moment from 'moment';
import popupHOC from '../../../common/popupHOC';
import TimePicker from 'rc-time-picker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { timeFormatUi } from '../../../../constants/date';
import { maxWorkingMinutesValue, minJobHoursValue, workerBreakMinutesValues } from '../../../../constants/jobs';
import { alertMessages, errorMaxJobHoursMessage, errorMinWorkerHoursMessage } from '../../../../constants/text';
import { calculateActualHours } from '../../../../helpers/jobs';
import { isJobTimelineValid } from '../../../../helpers/date';
import UsersService from '../../../../services/UsersService';

import 'rc-time-picker/assets/index.css';

class HoursPopup extends Component {
  static propTypes = {
    jobStartDate: PropTypes.object.isRequired,
    jobEndDate: PropTypes.object.isRequired,
    actual_hours: PropTypes.number,
    workerStartTime: PropTypes.object,
    workerEndTime: PropTypes.object,
    workerBreakOptions: PropTypes.object,
    closeMenu: PropTypes.func.isRequired,
    openMenu: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    saveWorkerChanges: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      startTime: props.workerStartTime || props.jobStartDate,
      endTime: props.workerEndTime || props.jobEndDate,
      selectedBreakOption: props.workerBreakOptions,
      minJobHoursMessage: false,
      maxJobHoursMessage: false
    };
  }

  handleChangeStartTime = value => {
    this.setState({
      startTime: value,
      minJobHoursMessage: false,
      maxJobHoursMessage: false
    });
  };

  handleChangeEndTime = value => {
    const { jobStartDate } = this.props;
    const { startTime } = this.state;
    let endTime = null;
    if (value) {
      endTime = jobStartDate.clone().set({
        hours: value.get('hours'),
        minutes: value.get('minutes')
      });
      if (startTime.isSameOrAfter(endTime)) {
        endTime.add(1, 'days');
      }
    }
    this.setState({
      endTime,
      minJobHoursMessage: false,
      maxJobHoursMessage: false
    });
  };

  handleChangeBreak = selectedBreakOption => {
    this.setState({ selectedBreakOption });
  };

  resetJobTimeline = () => this.setState({
    endTime: null,
    selectedBreakOption: null,
    startTime: this.props.jobStartDate
  });

  handleJobTimelineError = () => {
    this.resetJobTimeline();

    this.props.UIShowAlert(alertMessages.jobTimelineError);
  };

  saveChanges = e => {
    e.preventDefault();
    const { startTime, endTime, selectedBreakOption } = this.state;
    const break_time = selectedBreakOption && selectedBreakOption.value;
    const jobWorkingDurationMin = endTime.diff(startTime, 'minutes');
    const actual_hours = calculateActualHours(startTime, endTime, break_time);

    if (jobWorkingDurationMin === 0 || jobWorkingDurationMin > maxWorkingMinutesValue) {
      this.setState({
        maxJobHoursMessage: true
      });
      return;
    } else if (!UsersService.isAdmin() && actual_hours < minJobHoursValue) {
      this.setState({
        minJobHoursMessage: true
      });
      return;
    }

    const _isJobTimelineValid = isJobTimelineValid(startTime, endTime, calculateActualHours(startTime, endTime, break_time));

    if (!_isJobTimelineValid) {
      return this.handleJobTimelineError();
    }

    const { saveWorkerChanges, closeMenu } = this.props;
    saveWorkerChanges({
      actual_hours,
      job_start_time: moment.utc(startTime).format(),
      job_end_time: moment.utc(endTime).format(),
      break_time: break_time ? break_time / 60 : break_time
    });

    this.setState({
      minJobHoursMessage: false,
      maxJobHoursMessage: false
    });
    closeMenu();
  };

  render () {
    const { isOpen, openMenu, closeMenu, actual_hours } = this.props;
    const { startTime, endTime, selectedBreakOption, minJobHoursMessage, maxJobHoursMessage } = this.state;
    return (
      <div className='hours-popup change-hours-popup position-relative'>
        <button
          className='button button-primary'
          onClick={openMenu}
        >{ actual_hours ? 'Edit Hours' : 'Add Hours' }</button>
        { isOpen && (
          <div className='popupMenu'>
            <header className='d-flex justify-content-between px-3 py-2'>
              <p>Worked Hours</p>
              <button
                type='button'
                className='non-button close-popup-icon'
                onClick={closeMenu}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </header>
            <form onSubmit={this.saveChanges}>
              <div className='d-flex align-center px-3 py-2'>
                <label className='enter-hours-label'>Start time</label>
                <TimePicker
                  showSecond={false}
                  className='time-picker-wrapper'
                  onChange={this.handleChangeStartTime}
                  format={timeFormatUi}
                  use12Hours
                  minuteStep={15}
                  value={startTime}
                  defaultOpenValue={moment().startOf('day')}
                />
              </div>
              <div className='d-flex align-center px-3 py-2'>
                <label className='enter-hours-label'>End time</label>
                <TimePicker
                  showSecond={false}
                  className='time-picker-wrapper'
                  onChange={this.handleChangeEndTime}
                  format={timeFormatUi}
                  use12Hours
                  minuteStep={15}
                  value={endTime}
                  defaultOpenValue={moment().startOf('day')}
                />
              </div>
              <div className='d-flex align-center px-3 py-2'>
                <label className='enter-hours-label'>Break</label>
                <Select
                  onChange={this.handleChangeBreak}
                  options={workerBreakMinutesValues}
                  placeholder=''
                  className='time-picker-wrapper'
                  value={selectedBreakOption}
                  matchProp='label'
                />
              </div>
              {minJobHoursMessage && (
                <p className='px-3 py-1 error-message'>{ errorMinWorkerHoursMessage }</p>
              )}
              {maxJobHoursMessage && (
                <p className='px-3 py-1 error-message'>{ errorMaxJobHoursMessage }</p>
              )}
              <button
                className='button button-primary d-block mt-2 mb-3 mx-auto'
                disabled={!startTime || !endTime}
              >Submit</button>
            </form>
          </div>
        )}
      </div>
    );
  }
}

export default popupHOC(HoursPopup);



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/WorkersTab/HoursPopup.js